function formatDatetime (date) {
    if (date !== null && date !== undefined && date !== "" && date !== "1900-01-01T00:00:00"){
        const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };
        const formattedDate = new Date(date).toLocaleDateString('es-MX', optionsDate);

        const optionsHour = { hour: 'numeric', minute: 'numeric', hour12: true };
        const hora = new Date(date).toLocaleTimeString('en-US', optionsHour);

        //PARTIMOS LA FECHA POR LOS ESPACIOS
        const [day, month, year] = formattedDate.split(' de ');

        //REREGRESAMOS UN LITERAL STRING ARMANDO EL FORMATO DESEADO
        return `${day}/${month}/${year} - ${hora}`;
    }
    else return '';
    
}

export default formatDatetime;